/**
 * VIP（Stack）ヘッダー「保有ポイント」表示。
 * Liquid の customer / メタフィールドが空でも、ログインセッションがあれば SDK で利用可能ポイントを取得する。
 * @see https://www.npmjs.com/package/@builtbystack/vip-theme-sdk
 */
(function vipHeaderPoints() {
  var maxAttempts = 40;
  var intervalMs = 50;

  function queryTargets() {
    return document.querySelectorAll("[data-vip-approved-points]");
  }

  function run() {
    var VipApp = window.VipApp;
    if (!VipApp || !VipApp.VIPAppSDK) return false;

    var els = queryTargets();
    if (!els.length) return true;

    var origin = window.location.origin;
    var sdk = new VipApp.VIPAppSDK(origin);

    sdk
      .customerApprovedPoint()
      .then(function (res) {
        if (!res || typeof res.approvedPoint !== "number" || Number.isNaN(res.approvedPoint)) return;
        var text = String(res.approvedPoint);
        els.forEach(function (el) {
          el.textContent = text;
        });
      })
      .catch(function () {});

    return true;
  }

  function attempt(n) {
    if (run()) return;
    if (n >= maxAttempts) return;
    setTimeout(function () {
      attempt(n + 1);
    }, intervalMs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      attempt(0);
    });
  } else {
    attempt(0);
  }
})();

/**
 * VIP ポイント入力の placeholder はアプリ側文言のためテーマ内に無い。
 * `main-cart.liquid` の data-vip-point-input-placeholder（翻訳）で上書きする。
 */
(function vipCartPointInputPlaceholder() {
  var root = document.querySelector(".cart__recap-block--vip-points-form[data-vip-point-input-placeholder]");
  if (!root) return;

  var text = root.getAttribute("data-vip-point-input-placeholder");
  if (!text) return;

  function apply() {
    root.querySelectorAll('input#point, input[name="point"]').forEach(function (el) {
      if (el && el.tagName !== "INPUT") return;
      if (el.getAttribute("placeholder") === text) return;
      el.setAttribute("placeholder", text);
    });
  }

  var debounceTimer;
  function applyDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(apply, 120);
  }

  function start() {
    apply();
    var obs = new MutationObserver(function () {
      applyDebounced();
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
